export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/oracle.7a166b3.svg";